import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero__overlay" />
      <div className="hero__content">
       
        <h1 className="hero__title">
          Energizing Future with<br />
          <em>Sustainable Energy</em><br />
          Solutions
        </h1>
        <p className="hero__desc">
          TechB Energy delivers technology-agnostic renewable energy and battery storage solutions, combining cutting-edge technology, expert installation, and strategic consulting to deliver smarter, scalable, and future-ready energy solutions tailored to every project.

        </p>
        <div className="hero__actions">
          <a href="#contact" className="btn-primary">Contact Us →</a>
          <a href="#services" className="btn-outline">Explore Services</a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
